import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './BasicAlgebra.grid'
import { getProperties } from './BasicAlgebra.properties'

export default function BasicAlgebra({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(22,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(10,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(10,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={1900} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          height={856}
          image="math-drills/basic-algebra/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.basicAlgebraBeanStalkDesktop')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-10 -left-12 w-[885px]"
          height={900}
          image="math-drills/basic-algebra/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.basicAlgebraBeanStalkTablet')}
        />
      </div>
      <DrillTopicGridLayout className={`mb-12 ${[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}`}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
